import { axiosRequest } from './../../service/axios';

export const login = (data) => {
  const url = 'auth/login';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const logout = () => {
  const url = 'auth/logout';
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const setPassword = (data) => {
  const url = 'auth/set-password';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const resetPasswordMail = (data) => {
  const url = 'auth/reset-password-email';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const resetPassword = (data) => {
  const url = 'auth/reset-password';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const unblockUser = (data) => {
  const url = 'auth/unblock';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};
